module.exports = __webpack_public_path__ + "de3e37e291ffee2c8edb7d3288009d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-cat-sorry.png
// module id = 2052
// module chunks = 4